import { render } from "./SingleOverdueWarning.vue?vue&type=template&id=513f4d65"
import script from "./SingleOverdueWarning.vue?vue&type=script&lang=js"
export * from "./SingleOverdueWarning.vue?vue&type=script&lang=js"

import "./SingleOverdueWarning.vue?vue&type=style&index=0&id=513f4d65&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__